import { customSessionStorage, getQueryParam } from '@crehana/utils';

export const syncUtmsToSessionStorage = (utmsToGet: string[]) => {
  const isUtmValid = (_utm: any) => typeof _utm === 'string' && _utm.length > 0;

  utmsToGet.forEach(utmKey => {
    const utmValue = getQueryParam(utmKey);
    if (isUtmValid(utmValue)) {
      customSessionStorage.setItem(utmKey, utmValue as string);
    }
  });
};
